import type { DriveManagementCopy } from '@/i18n/drives-management-copy-types';

export const idDriveManagementCopy = {
  description: 'File bersama untuk tim, proyek, dan kolaborator.',
  createDrive: 'Buat Drive',
  createDriveTitle: 'Buat Drive Bersama',
  driveName: 'Nama Drive',
  driveNameHint: 'Nama Drive unik dan menjadi jalur folder yang mudah dibaca.',
  driveNameTaken: 'Drive bernama “{name}” sudah ada.',
  driveNameReserved: '“{name}” sudah dicadangkan. Pilih nama lain.',
  driveNameInvalid: 'Gunakan huruf atau angka dalam nama Drive.',
  driveNameSuggestions: 'Tersedia:',
  driveDescription: 'Deskripsi (opsional)',
  governance: 'Drive untuk',
  curatorOptIn: 'Jadikan saya Pengelola Pustaka',
  workspace: 'Workspace',
  teamGoverned: 'Tim',
  projectGoverned: 'Proyek',
  selectTeam: 'Pilih tim',
  selectProject: 'Pilih proyek',
  projectVisibility: 'Visibilitas proyek',
  assignedMembers: 'Anggota yang ditugaskan',
  workspaceVisible: 'Terlihat di workspace',
  customAudience: 'Audiens khusus',
  primaryProjectDrive: 'Jadikan Drive utama proyek',
  create: 'Buat',
  cancel: 'Batal',
  loading: 'Memuat Drive…',
  emptyTitle: 'Tidak ada Drive yang tersedia',
  emptyDescription: 'Buat Drive Bersama atau minta akses kepada Pengelola.',
  openDrive: 'Buka Drive',
  settings: 'Pengaturan Drive',
  members: 'Anggota',
  links: 'Tautan',
  permissions: 'Izin',
  workflow: 'Alur kerja',
  activity: 'Aktivitas',
  storage: 'Penyimpanan',
  role: 'Peran',
  status: 'Status',
  usage: 'Penyimpanan terpakai',
  restrictedFolders: 'Folder terbatas',
  guestManagement: 'Pengelolaan tamu',
  createFailed: 'Drive tidak dapat dibuat.',
  addMember: 'Tambah anggota',
  removeMember: 'Hapus',
  selectMember: 'Pilih anggota workspace',
  noDirectMembers: 'Belum ada anggota langsung.',
  unknownMember: 'Anggota tidak dikenal',
  loadMoreMembers: 'Muat lebih banyak anggota',
  memberAdded: 'Anggota ditambahkan.',
  memberRemoved: 'Anggota dihapus.',
  membersFailed: 'Anggota Drive tidak dapat diperbarui.',
  managerOnly: 'Hanya Pengelola Drive yang dapat mengelola anggota.',
  linkType: 'Jenis tautan',
  selectLinkTarget: 'Pilih tim atau proyek',
  addLink: 'Tambah tautan',
  removeLink: 'Hapus',
  noLinks: 'Drive ini tidak memiliki tautan tim atau proyek.',
  unknownLink: 'Konteks tidak tersedia',
  linkAdded: 'Tautan Drive ditambahkan.',
  linkRemoved: 'Tautan Drive dihapus.',
  linksFailed: 'Tautan Drive tidak dapat diperbarui.',
  viewerDownloads: 'Izinkan Pelihat mengunduh',
  publicLinksWorkspacePolicy:
    'Tautan publik tetap dikendalikan oleh kebijakan pemilik workspace.',
  selectFolder: 'Pilih folder',
  restrict: 'Batasi',
  removeRestriction: 'Hapus batas',
  boundaryCreated: 'Batas folder terbatas dibuat.',
  boundaryRemoved: 'Batas folder terbatas dihapus.',
  createWorkflow: 'Buat alur kerja default',
  workflowCreated: 'Alur kerja default dibuat.',
  noWorkflows: 'Tidak ada alur kerja yang dikonfigurasi untuk Drive ini.',
  noActivity: 'Belum ada aktivitas Drive.',
  activityAccess: 'Akses diubah',
  activityContent: 'Aktivitas konten',
  activityWorkflow: 'Aktivitas alur kerja',
  activityPublish: 'Aktivitas publikasi',
  activityGovernance: 'Pengaturan Drive diperbarui',
  activityRecovery: 'Aktivitas pemulihan',
  activitySecurity: 'Aktivitas keamanan',
  activityAutomation: 'Aktivitas agen',
  activityDrive: 'Drive diperbarui',
  policyUpdated: 'Kebijakan Drive diperbarui.',
  settingsFailed: 'Pengaturan Drive tidak dapat diperbarui.',
  guestEmail: 'Email akun tamu',
  addGuest: 'Tambah tamu',
  guestAdded: 'Tamu ditambahkan sebagai Pengomentar.',
  guestFailed:
    'Tamu ini tidak dapat ditambahkan. Mereka harus sudah memiliki identitas IMAI.',
  guestExpiry:
    'Akses tamu secara default berakhir setelah 90 hari dan dibatasi hingga Kontributor.',
  recovery: 'Pemulihan',
  contentAccessRequired: 'Akses konten diperlukan',
  recoveryDescription:
    'Tetapkan Pengelola pengganti tanpa membuka atau melihat konten Drive.',
  replacementManager: 'Pilih Pengelola pengganti',
  assignManager: 'Tetapkan Pengelola',
  recoveryAssigned: 'Pengelola pengganti ditetapkan.',
  recoveryFailed: 'Pengelola pengganti tidak dapat ditetapkan.',
  publishToLibrary: 'Publikasikan ke Drive Workspace',
  publish: 'Publikasikan',
  publishStarted: 'Salinan Pustaka terkelola dimulai.',
  publishFailed: 'File ini tidak dapat dipublikasikan.',
  noPublishableFiles: 'Drive ini tidak memiliki file untuk dipublikasikan.',
  libraryCuratorRequired:
    'Akses Pengelola Konten Pustaka diperlukan untuk memublikasikan.',
} satisfies DriveManagementCopy;

export const itDriveManagementCopy = {
  description: 'File condivisi per team, progetti e collaboratori.',
  createDrive: 'Crea Drive',
  createDriveTitle: 'Crea un Drive condiviso',
  driveName: 'Nome del Drive',
  driveNameHint: 'I nomi sono univoci e diventano il percorso leggibile.',
  driveNameTaken: 'Esiste già un Drive chiamato “{name}”.',
  driveNameReserved: '“{name}” è riservato. Scegli un altro nome.',
  driveNameInvalid: 'Usa lettere o numeri nel nome del Drive.',
  driveNameSuggestions: 'Disponibili:',
  driveDescription: 'Descrizione (facoltativa)',
  governance: 'Drive per',
  curatorOptIn: 'Rendimi Gestore della libreria',
  workspace: 'Spazio di lavoro',
  teamGoverned: 'Team',
  projectGoverned: 'Progetto',
  selectTeam: 'Seleziona un team',
  selectProject: 'Seleziona un progetto',
  projectVisibility: 'Visibilità del progetto',
  assignedMembers: 'Membri assegnati',
  workspaceVisible: 'Visibile nello spazio di lavoro',
  customAudience: 'Pubblico personalizzato',
  primaryProjectDrive: 'Imposta come Drive principale del progetto',
  create: 'Crea',
  cancel: 'Annulla',
  loading: 'Caricamento dei Drive…',
  emptyTitle: 'Nessun Drive disponibile',
  emptyDescription: 'Crea un Drive condiviso o chiedi accesso a un Gestore.',
  openDrive: 'Apri Drive',
  settings: 'Impostazioni del Drive',
  members: 'Membri',
  links: 'Collegamenti',
  permissions: 'Autorizzazioni',
  workflow: 'Flusso di lavoro',
  activity: 'Attività',
  storage: 'Archiviazione',
  role: 'Ruolo',
  status: 'Stato',
  usage: 'Spazio utilizzato',
  restrictedFolders: 'Cartelle con restrizioni',
  guestManagement: 'Gestione degli ospiti',
  createFailed: 'Impossibile creare il Drive.',
  addMember: 'Aggiungi membro',
  removeMember: 'Rimuovi',
  selectMember: 'Seleziona un membro dello spazio',
  noDirectMembers: 'Nessun membro diretto per ora.',
  unknownMember: 'Membro sconosciuto',
  loadMoreMembers: 'Carica altri membri',
  memberAdded: 'Membro aggiunto.',
  memberRemoved: 'Membro rimosso.',
  membersFailed: 'Impossibile aggiornare i membri del Drive.',
  managerOnly: 'Solo i Gestori del Drive possono gestire i membri.',
  linkType: 'Tipo di collegamento',
  selectLinkTarget: 'Seleziona un team o un progetto',
  addLink: 'Aggiungi collegamento',
  removeLink: 'Rimuovi',
  noLinks: 'Questo Drive non ha collegamenti a team o progetti.',
  unknownLink: 'Contesto non disponibile',
  linkAdded: 'Collegamento del Drive aggiunto.',
  linkRemoved: 'Collegamento del Drive rimosso.',
  linksFailed: 'Impossibile aggiornare i collegamenti del Drive.',
  viewerDownloads: 'Consenti il download al Visualizzatore',
  publicLinksWorkspacePolicy:
    'I collegamenti pubblici restano soggetti alla policy del proprietario dello spazio.',
  selectFolder: 'Seleziona una cartella',
  restrict: 'Limita',
  removeRestriction: 'Rimuovi limite',
  boundaryCreated: 'Limite della cartella con restrizioni creato.',
  boundaryRemoved: 'Limite della cartella con restrizioni rimosso.',
  createWorkflow: 'Crea flusso predefinito',
  workflowCreated: 'Flusso predefinito creato.',
  noWorkflows: 'Nessun flusso configurato per questo Drive.',
  noActivity: 'Nessuna attività del Drive per ora.',
  activityAccess: 'Accesso modificato',
  activityContent: 'Attività sui contenuti',
  activityWorkflow: 'Attività del flusso di lavoro',
  activityPublish: 'Attività di pubblicazione',
  activityGovernance: 'Impostazioni Drive aggiornate',
  activityRecovery: 'Attività di recupero',
  activitySecurity: 'Attività di sicurezza',
  activityAutomation: 'Attività dell’agente',
  activityDrive: 'Drive aggiornato',
  policyUpdated: 'Policy del Drive aggiornata.',
  settingsFailed: 'Impossibile aggiornare le impostazioni del Drive.',
  guestEmail: 'Email dell’account ospite',
  addGuest: 'Aggiungi ospite',
  guestAdded: 'Ospite aggiunto come Commentatore.',
  guestFailed:
    'Impossibile aggiungere questo ospite. Deve già avere un’identità IMAI.',
  guestExpiry:
    'L’accesso ospite scade dopo 90 giorni per impostazione predefinita ed è limitato a Collaboratore.',
  recovery: 'Recupero',
  contentAccessRequired: 'Accesso ai contenuti richiesto',
  recoveryDescription:
    'Assegna un Gestore sostitutivo senza aprire o visualizzare i contenuti.',
  replacementManager: 'Seleziona un Gestore sostitutivo',
  assignManager: 'Assegna Gestore',
  recoveryAssigned: 'Gestore sostitutivo assegnato.',
  recoveryFailed: 'Impossibile assegnare il Gestore sostitutivo.',
  publishToLibrary: 'Pubblica nel Drive dello spazio',
  publish: 'Pubblica',
  publishStarted: 'Copia gestita della Libreria avviata.',
  publishFailed: 'Impossibile pubblicare questo file.',
  noPublishableFiles: 'Questo Drive non contiene file da pubblicare.',
  libraryCuratorRequired:
    'Per pubblicare è richiesto il ruolo Gestore contenuti della Libreria.',
} satisfies DriveManagementCopy;

export const jaDriveManagementCopy = {
  description: 'チーム、プロジェクト、共同作業者向けの共有ファイル。',
  createDrive: 'ドライブを作成',
  createDriveTitle: '共有ドライブを作成',
  driveName: 'ドライブ名',
  driveNameHint: 'ドライブ名は一意で、読みやすいフォルダーパスになります。',
  driveNameTaken: '「{name}」という名前のドライブはすでに存在します。',
  driveNameReserved: '「{name}」は予約されています。別の名前を選んでください。',
  driveNameInvalid: 'ドライブ名には英字または数字を使用してください。',
  driveNameSuggestions: '使用可能:',
  driveDescription: '説明（任意）',
  governance: 'ドライブの対象',
  curatorOptIn: '自分をライブラリ管理者にする',
  workspace: 'ワークスペース',
  teamGoverned: 'チーム',
  projectGoverned: 'プロジェクト',
  selectTeam: 'チームを選択',
  selectProject: 'プロジェクトを選択',
  projectVisibility: 'プロジェクトの公開範囲',
  assignedMembers: '割り当てられたメンバー',
  workspaceVisible: 'ワークスペースに公開',
  customAudience: 'カスタム対象者',
  primaryProjectDrive: 'プロジェクトのメインドライブにする',
  create: '作成',
  cancel: 'キャンセル',
  loading: 'ドライブを読み込んでいます…',
  emptyTitle: '利用可能なドライブがありません',
  emptyDescription:
    '共有ドライブを作成するか、管理者にアクセスを依頼してください。',
  openDrive: 'ドライブを開く',
  settings: 'ドライブ設定',
  members: 'メンバー',
  links: 'リンク',
  permissions: '権限',
  workflow: 'ワークフロー',
  activity: 'アクティビティ',
  storage: 'ストレージ',
  role: '役割',
  status: 'ステータス',
  usage: '使用中のストレージ',
  restrictedFolders: '制限付きフォルダー',
  guestManagement: 'ゲスト管理',
  createFailed: 'ドライブを作成できませんでした。',
  addMember: 'メンバーを追加',
  removeMember: '削除',
  selectMember: 'ワークスペースのメンバーを選択',
  noDirectMembers: '直接追加されたメンバーはまだいません。',
  unknownMember: '不明なメンバー',
  loadMoreMembers: 'さらにメンバーを読み込む',
  memberAdded: 'メンバーを追加しました。',
  memberRemoved: 'メンバーを削除しました。',
  membersFailed: 'ドライブのメンバーを更新できませんでした。',
  managerOnly: 'メンバーを管理できるのはドライブ管理者のみです。',
  linkType: 'リンクの種類',
  selectLinkTarget: 'チームまたはプロジェクトを選択',
  addLink: 'リンクを追加',
  removeLink: '削除',
  noLinks: 'このドライブにはチームまたはプロジェクトのリンクがありません。',
  unknownLink: '利用できないコンテキスト',
  linkAdded: 'ドライブリンクを追加しました。',
  linkRemoved: 'ドライブリンクを削除しました。',
  linksFailed: 'ドライブリンクを更新できませんでした。',
  viewerDownloads: '閲覧者のダウンロードを許可',
  publicLinksWorkspacePolicy:
    '公開リンクには引き続きワークスペース所有者のポリシーが適用されます。',
  selectFolder: 'フォルダーを選択',
  restrict: '制限',
  removeRestriction: '境界を削除',
  boundaryCreated: '制限付きフォルダーの境界を作成しました。',
  boundaryRemoved: '制限付きフォルダーの境界を削除しました。',
  createWorkflow: '既定のワークフローを作成',
  workflowCreated: '既定のワークフローを作成しました。',
  noWorkflows: 'このドライブにはワークフローが設定されていません。',
  noActivity: 'ドライブのアクティビティはまだありません。',
  activityAccess: 'アクセスを変更',
  activityContent: 'コンテンツのアクティビティ',
  activityWorkflow: 'ワークフローのアクティビティ',
  activityPublish: '公開のアクティビティ',
  activityGovernance: 'ドライブ設定を更新',
  activityRecovery: '復旧のアクティビティ',
  activitySecurity: 'セキュリティのアクティビティ',
  activityAutomation: 'エージェントのアクティビティ',
  activityDrive: 'ドライブを更新',
  policyUpdated: 'ドライブポリシーを更新しました。',
  settingsFailed: 'ドライブ設定を更新できませんでした。',
  guestEmail: 'ゲストアカウントのメール',
  addGuest: 'ゲストを追加',
  guestAdded: 'ゲストをコメント投稿者として追加しました。',
  guestFailed: 'ゲストを追加できませんでした。既存の IMAI ID が必要です。',
  guestExpiry:
    'ゲストアクセスは既定で90日後に期限切れとなり、投稿者までに制限されます。',
  recovery: '復旧',
  contentAccessRequired: 'コンテンツへのアクセスが必要です',
  recoveryDescription:
    'ドライブのコンテンツを開いたり表示したりせずに、後任の管理者を割り当てます。',
  replacementManager: '後任の管理者を選択',
  assignManager: '管理者を割り当て',
  recoveryAssigned: '後任の管理者を割り当てました。',
  recoveryFailed: '後任の管理者を割り当てられませんでした。',
  publishToLibrary: 'ワークスペース ドライブに公開',
  publish: '公開',
  publishStarted: '管理対象のライブラリコピーを開始しました。',
  publishFailed: 'このファイルを公開できませんでした。',
  noPublishableFiles: 'このドライブには公開できるファイルがありません。',
  libraryCuratorRequired:
    '公開するにはライブラリのコンテンツ管理者権限が必要です。',
} satisfies DriveManagementCopy;

export const koDriveManagementCopy = {
  description: '팀, 프로젝트 및 공동 작업자를 위한 공유 파일입니다.',
  createDrive: '드라이브 만들기',
  createDriveTitle: '공유 드라이브 만들기',
  driveName: '드라이브 이름',
  driveNameHint: '드라이브 이름은 고유하며 읽기 쉬운 폴더 경로가 됩니다.',
  driveNameTaken: '“{name}” 드라이브가 이미 있습니다.',
  driveNameReserved:
    '“{name}”은(는) 예약된 이름입니다. 다른 이름을 선택하세요.',
  driveNameInvalid: '드라이브 이름에 영문자나 숫자를 사용하세요.',
  driveNameSuggestions: '사용 가능:',
  driveDescription: '설명(선택 사항)',
  governance: '드라이브 대상',
  curatorOptIn: '나를 라이브러리 관리자로 지정',
  workspace: '워크스페이스',
  teamGoverned: '팀',
  projectGoverned: '프로젝트',
  selectTeam: '팀 선택',
  selectProject: '프로젝트 선택',
  projectVisibility: '프로젝트 공개 범위',
  assignedMembers: '배정된 멤버',
  workspaceVisible: '워크스페이스에 공개',
  customAudience: '사용자 지정 대상',
  primaryProjectDrive: '프로젝트의 기본 드라이브로 설정',
  create: '만들기',
  cancel: '취소',
  loading: '드라이브를 불러오는 중…',
  emptyTitle: '사용 가능한 드라이브가 없습니다',
  emptyDescription: '공유 드라이브를 만들거나 관리자에게 액세스를 요청하세요.',
  openDrive: '드라이브 열기',
  settings: '드라이브 설정',
  members: '멤버',
  links: '연결',
  permissions: '권한',
  workflow: '워크플로',
  activity: '활동',
  storage: '저장용량',
  role: '역할',
  status: '상태',
  usage: '사용 중인 저장용량',
  restrictedFolders: '제한된 폴더',
  guestManagement: '게스트 관리',
  createFailed: '드라이브를 만들 수 없습니다.',
  addMember: '멤버 추가',
  removeMember: '삭제',
  selectMember: '워크스페이스 멤버 선택',
  noDirectMembers: '직접 추가된 멤버가 아직 없습니다.',
  unknownMember: '알 수 없는 멤버',
  loadMoreMembers: '멤버 더 불러오기',
  memberAdded: '멤버를 추가했습니다.',
  memberRemoved: '멤버를 삭제했습니다.',
  membersFailed: '드라이브 멤버를 업데이트할 수 없습니다.',
  managerOnly: '드라이브 관리자만 멤버를 관리할 수 있습니다.',
  linkType: '연결 유형',
  selectLinkTarget: '팀 또는 프로젝트 선택',
  addLink: '연결 추가',
  removeLink: '삭제',
  noLinks: '이 드라이브에는 팀 또는 프로젝트 연결이 없습니다.',
  unknownLink: '사용할 수 없는 컨텍스트',
  linkAdded: '드라이브 연결을 추가했습니다.',
  linkRemoved: '드라이브 연결을 삭제했습니다.',
  linksFailed: '드라이브 연결을 업데이트할 수 없습니다.',
  viewerDownloads: '뷰어의 다운로드 허용',
  publicLinksWorkspacePolicy:
    '공개 링크에는 계속 워크스페이스 소유자 정책이 적용됩니다.',
  selectFolder: '폴더 선택',
  restrict: '제한',
  removeRestriction: '경계 삭제',
  boundaryCreated: '제한 폴더 경계를 만들었습니다.',
  boundaryRemoved: '제한 폴더 경계를 삭제했습니다.',
  createWorkflow: '기본 워크플로 만들기',
  workflowCreated: '기본 워크플로를 만들었습니다.',
  noWorkflows: '이 드라이브에 구성된 워크플로가 없습니다.',
  noActivity: '아직 드라이브 활동이 없습니다.',
  activityAccess: '액세스 변경됨',
  activityContent: '콘텐츠 활동',
  activityWorkflow: '워크플로 활동',
  activityPublish: '게시 활동',
  activityGovernance: '드라이브 설정 업데이트됨',
  activityRecovery: '복구 활동',
  activitySecurity: '보안 활동',
  activityAutomation: '에이전트 활동',
  activityDrive: '드라이브 업데이트됨',
  policyUpdated: '드라이브 정책을 업데이트했습니다.',
  settingsFailed: '드라이브 설정을 업데이트할 수 없습니다.',
  guestEmail: '게스트 계정 이메일',
  addGuest: '게스트 추가',
  guestAdded: '게스트를 댓글 작성자로 추가했습니다.',
  guestFailed: '게스트를 추가할 수 없습니다. 기존 IMAI ID가 필요합니다.',
  guestExpiry:
    '게스트 액세스는 기본적으로 90일 후 만료되며 기여자 역할까지만 허용됩니다.',
  recovery: '복구',
  contentAccessRequired: '콘텐츠 액세스 필요',
  recoveryDescription:
    '드라이브 콘텐츠를 열거나 보지 않고 대체 관리자를 지정합니다.',
  replacementManager: '대체 관리자 선택',
  assignManager: '관리자 지정',
  recoveryAssigned: '대체 관리자를 지정했습니다.',
  recoveryFailed: '대체 관리자를 지정할 수 없습니다.',
  publishToLibrary: '워크스페이스 드라이브에 게시',
  publish: '게시',
  publishStarted: '관리형 라이브러리 복사를 시작했습니다.',
  publishFailed: '이 파일을 게시할 수 없습니다.',
  noPublishableFiles: '이 드라이브에는 게시할 파일이 없습니다.',
  libraryCuratorRequired:
    '게시하려면 라이브러리 콘텐츠 관리자 액세스가 필요합니다.',
} satisfies DriveManagementCopy;
